import { FilterProperty, FilterType, IFilter } from "@/types/filter.types";
import { RequestPagination } from "@/types/requests.types";

export function buildPaginationQuery(pagination: RequestPagination): string {
  const { pageNumber, pageSize } = pagination;
  return `pageNumber=${pageNumber}&pageSize=${pageSize}`;
}

// This function normalizes date filters from the form, converting registrationDateStart and registrationDateEnd
// into API-compatible filters for 'rowdate' with the correct filterType (GreaterThan/LessThan).
function normalizeDateFilters<T>(filters: IFilter<T>[]): IFilter<T>[] {
  const dateFilters: IFilter<T>[] = [];
  filters.forEach((filter) => {
    if (filter.property === "registrationDateStart" && filter.value) {
      dateFilters.push({
        property: "rowdate" as FilterProperty<T>,
        filterType: FilterType.GreaterThan,
        value: `${filter.value} 00:00:00`,
      });
    } else if (filter.property === "registrationDateEnd" && filter.value) {
      dateFilters.push({
        property: "rowdate" as FilterProperty<T>,
        filterType: FilterType.LessThan,
        value: `${filter.value} 00:00:00`,
      });
    }
  });
  return dateFilters;
}

// This function normalizes the filter array for API requests.
// It delegates date normalization to normalizeDateFilters and merges with other filters.
export const normalizeSingleFilterFormData = <T>(
  formData: IFilter<T>[],
  defaultProperty: FilterProperty<T>
) => {
  if (formData.length === 0) {
    // If no filters, return a default filter for the main property
    return [{ property: defaultProperty, value: "", filterType: FilterType.Contains }];
  }
  if (formData[0].property === "all") {
    // If the filter is for 'all', replace property with the default
    return [{ ...formData[0], property: defaultProperty }];
  }

  // Separate date filters from other filters
  const dateFilters = normalizeDateFilters(formData);
  const otherFilters = formData.filter(
    (filter) =>
      filter.property !== "registrationDateStart" && filter.property !== "registrationDateEnd"
  );

  // Merge other filters with normalized date filters
  return [...otherFilters, ...dateFilters];
};
